import { render } from "./GridDrepturiRoluri.vue?vue&type=template&id=19540ba6&scoped=true&ts=true"
import script from "./GridDrepturiRoluri.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiRoluri.vue?vue&type=script&lang=ts"

import "./GridDrepturiRoluri.vue?vue&type=style&index=0&id=19540ba6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19540ba6"]])

export default __exports__